import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';

const TrackerSurveyState = ({tracker}) => {
    if (tracker.completedAt) {
        return <span className="badge badge-success"><FormattedMessage {...messages.trackers.list.completedSurvey} /></span>;
    }
    if (tracker.startedAt) {
        return <span className="badge badge-info"><FormattedMessage {...messages.trackers.list.startedSurvey} /></span>;
    }
    return <span className="badge badge-danger"><FormattedMessage {...messages.trackers.list.notStartedSurvey} /></span>;
};

export default TrackerSurveyState;
